import * as React from 'react';
export var AppStateContext = React.createContext([{}, function () {}]);
export var AppStateProvider = function AppStateProvider(_a) {
  var _b = _a.value,
      value = _b === void 0 ? {} : _b,
      children = _a.children;
  return React.createElement(AppStateContext.Provider, {
    value: React.useState(value)
  }, children);
};